export default "__VITE_ASSET__EFnPpLwM__"